import { MODAL_GA4_PROPERTY } from '@components/App/Modal/constants'
import type { ID } from '@octopus-do/octopus-project-core'
import { SeoActions } from '@store/reducers/seo/actions'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { openModal } from '@storeOld/reducers/ui'
import { call, put } from 'redux-saga/effects'

import API from '@/api'
import type { Ga4Actions } from '../actions'
import { InternalGa4Actions } from '../actions'
import { fetchReport } from './fetchReport'
import { waitForProjectId } from './waitForProject'

// Обмен припаркованного гранта на сохранённую интеграцию. Отдельным
// генератором, чтобы исход был возвращаемым значением, а не переприсваиваемым
// флагом.
export function* storeGrant(projectId: ID, pendingId: string) {
  yield put(InternalGa4Actions.connecting(true))

  try {
    yield call(API.GoogleAnalytics.complete, projectId, pendingId)

    return true
  } catch {
    // Припаркованный грант одноразовый и живёт 10 минут: перезагрузка
    // страницы или возврат по старой ссылке сюда и приводят.
    yield put(
      ErrorNotification('Google Analytics is not connected. Try again.')
    )

    return false
  } finally {
    yield put(InternalGa4Actions.connecting(false))
  }
}

export function* complete({ payload }: ReturnType<typeof Ga4Actions.complete>) {
  // Первым делом и до загрузки проекта: юзер ушёл на консент Google из
  // SEO-режима и возвращается в него же. Если ждать проект, артборд успевает
  // нарисоваться картой сайта, и переключение видно как скачок.
  yield put(SeoActions.enableMode())

  const projectId: ID | null = yield call(waitForProjectId)

  if (projectId === null) {
    return
  }

  const completed: boolean = yield call(storeGrant, projectId, payload)

  // Отчёт запрашиваем сами: watcher на changeMode отработал вхолостую — в тот
  // момент проекта в сторе ещё не было. На успехе ответ придёт no_property и
  // окно покажет пикер; на ошибке — то, что на сервере есть на самом деле, и
  // кнопка встанет в соответствующее состояние.
  yield call(fetchReport)

  if (completed) {
    yield put(openModal(MODAL_GA4_PROPERTY))
  }
}
